import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4491cbfc&scoped=true"
import script from "./Home.js?vue&type=script&lang=js&external"
export * from "./Home.js?vue&type=script&lang=js&external"
import style0 from "./Home.scss?vue&type=style&index=0&id=4491cbfc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4491cbfc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotOrganicHeader: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Organic/Header/Header.vue').default,HotHeader: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Header/Header.vue').default,HotHeaderSidebar: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/HeaderSidebar/HeaderSidebar.vue').default,HotHero: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Hero/Hero.vue').default,HotHomeNavigationCards: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/HomeNavigationCards/HomeNavigationCards.vue').default,HotFooter: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Footer/Footer.vue').default})
